import React from 'react';
import classNames from 'classnames/bind';
import { BannerGroup, Banner as BannerUI } from '@carnica/ui-kit';
import { withErrorBoundary } from '@beef/react';

import { BlockWrapper } from 'pages/MainPage/layout/BlockWrapper';

import { BannerCarouselItem } from './components/BannerCarouselItem';
import { BannerCarouselItemMobile } from './components/BannerCarouselItemMobile';
import { AdaptivityContainer } from '../../utils/ResponsiveContainers';
import { BannerCarouselProps } from './types';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

// TODO:В будущем надо такие компоненты учиться делать полностью на коннекторах, чтобы все пропсы были зашиты и брались из стора не в компоненте - а в отдельных вызовах стора
const _BannerCarouselBlock: React.FC<BannerCarouselProps> = ({
  slides,
  duration,
  sectionTitle,
}) => {
  const hasManySlides = slides?.length > 1;

  return (
    <div className={cx('carousel')}>
      <AdaptivityContainer minWidth={801}>
        <BlockWrapper className={cx({ 'many-slides': hasManySlides })}>
          <BannerGroup
            autoPlay
            className={cx('carousel-swiper')}
            duration={duration}
            infinite
            loop
            swiperOptions={{
              slideClass: cx({
                'carousel-one-slide': !hasManySlides,
                'swiper-slide': hasManySlides,
              }),
            }}
            withControls={hasManySlides}
          >
            {slides?.map((item, index) => (
              <BannerCarouselItem
                bannerId={index + 1}
                bannerPosition={`${index + 1}/${slides.length}`}
                item={item}
                key={index}
                sectionTitle={sectionTitle}
              />
            ))}
          </BannerGroup>
        </BlockWrapper>
      </AdaptivityContainer>
      <AdaptivityContainer maxWidth={800}>
        <BannerUI
          autoPlay
          className={cx('carousel-swiper')}
          duration={duration}
          infinite
          intersectionActivate={1}
          loop
          swiperOptions={{
            slideClass: cx('carousel-slide'),
          }}
          withControls={false}
        >
          {slides?.map((item, index) => (
            <BannerCarouselItemMobile
              bannerId={index + 1}
              bannerPosition={`${index + 1}/${slides.length}`}
              item={item}
              key={index}
              sectionTitle={sectionTitle}
            />
          ))}
        </BannerUI>
      </AdaptivityContainer>
    </div>
  );
};

export const BannerCarouselBlock = withErrorBoundary({ fallback: null })(_BannerCarouselBlock);
